window.dataLayer = window.dataLayer || [];
window.vacancyClicked = vacancyClicked;
window.jobboardSearchQuery = jobboardSearchQuery;
window.blogPostClicked = blogPostClicked;
window.faqItemClicked = faqItemClicked;
window.eventItemClicked = eventItemClicked;
window.formStartEvent = formStartEvent;
window.formStartStepEvent = formStartStepEvent;
window.formCompleteEvent = formCompleteEvent;
window.directContactClicked = directContactClicked;

let formStarted = false;

const pageName = document.currentScript.getAttribute('data-pageName');
const publicationDate = document.currentScript.getAttribute('data-publicationDate');

const CATEGORY_REGEX = {
    organisation: /organisat(?:ies|ions)/,
    freelancers: /freelancers?|freelances/
};

function checkContentCategoryRegex(path) {
    return Object.entries(CATEGORY_REGEX).find(
        ([_, regex]) => regex.test(path)
    )?.[0] || null;
}

// page load
document.addEventListener("DOMContentLoaded", () => {
    dataLayer.push({
        "event": "page_load",
        "data": {
            "page_name": `${pageName}`,
            "page_url": `${window.location}`,
            "content_category": checkContentCategoryRegex(window.location.pathname),
            "publication_date": `${publicationDate}`
        }
    });
});

// search_query
function jobboardSearchQuery(query, totalCount) {
    dataLayer.push({
        "event": "search_query",
        "data": {
            "level_1": "search",
            "level_2": "query",
            "level_3": hasValue(query.Keyword),
            "level_4": hasValue(query.Language),
            "level_5": hasValue(query.Location),
            "level_6": hasValue(query.Radius),
            "level_7": hasValue(query.PostalCodes),
            "level_8": hasValue(query.Companies),
            "level_9": hasValue(query.Mediums),
            "level_10": hasValue(query.ScheduleTypes),
            "level_11": hasValue(query.ContractTypes),
            "level_12": hasValue(query.JobFunctions),
            "level_13": hasValue(query.Branches),
            "level_14": hasValue(query.Sort),
            "level_15": hasValue(query.Since),
            "level_16": `${totalCount}`
        }
    })
}


// Joblisting clicked
function vacancyClicked(totalCount, index, query, title, pubId) {
    dataLayer.push({
        "event": "search_result_click",
        "data": {
            "level_1": "search",
            "level_2": "result_click",
            "level_3": hasValue(query.Keyword),
            "level_4": hasValue(query.Language),
            "level_5": hasValue(query.Location),
            "level_6": hasValue(query.Radius),
            "level_7": hasValue(query.PostalCodes),
            "level_8": hasValue(query.Companies),
            "level_9": hasValue(query.Mediums),
            "level_10": hasValue(query.ScheduleTypes),
            "level_11": hasValue(query.ContractTypes),
            "level_12": hasValue(query.JobFunctions),
            "level_13": hasValue(query.Branches),
            "level_14": hasValue(query.Sort),
            "level_15": hasValue(query.Since),
            "level_16": `${totalCount}`,
            "level_17": hasValue(query.Page),
            "level_18": `${index}`,
            "level_19": `${title}`,
            "level_20": `${pubId}`,
        }
    })
}

function blogPostClicked(totalCount, index, page, title) {
    const query = new URLSearchParams(location.search.substring(1));

    dataLayer.push({
        "event": "blog_post_click",
        "data": {
            "level_1": "blog",
            "level_2": "result_click",
            "level_3": hasValue(query.get('query')),
            "level_4": hasValue(query.get('tag')),
            "level_5": `${totalCount}`,
            "level_6": `${page}`,
            "level_7": `${index}`,
            "level_8": `${title}`,
        }
    })
}

function faqItemClicked(title) {
    dataLayer.push({
        "event": "faq_item_click",
        "data": {
            "level_1": "faq",
            "level_2": "result_click",
            "level_3": `${pageName}`,
            "level_4": `${title}`,
        }
    })
}

function eventItemClicked(title) {
    dataLayer.push({
        "event": "event_item_click",
        "data": {
            "level_1": "event",
            "level_2": "result_click",
            "level_3": `${title}`,
        }
    })
}

function formStartEvent(formStartEventOptions) {
    if(formStarted === true){
        return;
    }
    
    dataLayer.push({
        "event": `form_${formStartEventOptions.formName}_form_start`,
        "data": {
            "level_1": "form",
            "level_2": "form_start",
            "level_3": `${formStartEventOptions.formName}`,
            "level_4": `${formStartEventOptions.stepNumber}`,
            "level_5": `${pageName}`
        }
    });

    formStarted = true
}

function formStartStepEvent(formStartStepEventOptions) {
    dataLayer.push({
        "event": `form_${formStartStepEventOptions.formName}_step_start`,
        "data": {
            "level_1": "form",
            "level_2": "step_start",
            "level_3": `${formStartStepEventOptions.formName}`,
            "level_4": `${formStartStepEventOptions.stepNumber}`,
            "level_5": `${pageName}`
        }
    });
}

function formCompleteEvent(formCompleteEventOptions) {
    const eventData = {
        "level_1": "form",
        "level_2": "complete",
        "level_3": formCompleteEventOptions.formName,
        "level_4": formCompleteEventOptions.stepNumber,
        "level_5": `${pageName}`
    }

    const enhancedConversionsData = {
        "email": formCompleteEventOptions.enhancedConversions.email,
        "first_name" : formCompleteEventOptions.enhancedConversions.firstName,
        "last_name" : formCompleteEventOptions.enhancedConversions.lastName
    }

    
    dataLayer.push({
        "event": `form_${formCompleteEventOptions.formName}_complete`,
        "data": { ...eventData, ...enhancedConversionsData }
    });
}

function directContactClicked(location, type) {
    dataLayer.push({
        "event": "direct_contact_click",
        "data": {
            "level_1": `${type}`,
            "level_2": "contact_click",
            "level_3": `${location}`,
        }
    })
}

function hasValue(value) {
    if (value == null) return null;
    
    if (Array.isArray(value) && value.length === 0) return null;
    
    if (typeof value === 'string' && value.trim() === '') return null;
    
    if (typeof value === 'object' && Object.keys(value).length === 0) return null;
    
    if (typeof value === 'number' && isNaN(value)) return null;
    
    return value;
};
